module.exports = __webpack_public_path__ + "assets/bell-f18de6.svg";